<template>
  <div>
    <label class="v-label theme--light" :class="[labelActive, invalid ? 'error--text' : '']">{{ $props.label }}</label>
    <canvas ref="canvas" :width="width" :height="height" :class="invalid ? 'invalid' : ''"></canvas>
    <div class="v-messages theme--light" :class="invalid ? 'error--text' : ''" role="alert"><div class="v-messages__wrapper"><div class="v-messages__message">{{ invalid ? $props.message : '' }}</div></div></div>
  </div>
</template>

<script>
import SignaturePad from "signature_pad"

export default {
  name: "SignaturePad",
  props: {
    width: {
      type: String,
      default: "500px",
    },
    height: {
      type: String,
      default: "200px",
    },
    label: {
      type: String,
      default: "Signature",
    },
    required: Boolean,
    message: String
  },
  data: () => ({
    signature: {},
    hideLabel: false,
    labelActive: "",
    invalid: false,
  }),
  mounted() {
    const canvas = this.$refs.canvas

    const opts = {
      onBegin: () => {
        this.labelActive = "active"
        this.invalid = false
    }}

    this.signature = new SignaturePad(canvas, opts)
  },
  methods: {
    toDataURL() {
      return this.signature.toDataURL()
    },
    clear() {
      this.signature.clear()
      this.labelActive = ""
      this.invalid = false
    },
    isEmpty() {
      return this.signature.isEmpty()
    },
    validate() {
      if (this.$props.required) {
        this.invalid = this.signature.isEmpty()
        return !this.invalid
      }
      return true
    }
  }
}
</script>

<style scoped>
canvas {
  border: 1px solid rgba(0,0,0,0.42);
}
canvas.invalid {
  border: 1px solid #ff5252;
}
label {
  position: absolute;
  margin: 10px;
  padding: 0 3px;
}
label.active {
  font-size: 75%;
  margin-top: -6px;
  background: white;
}
</style>
